import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const languageSelectionRoutes: Routes = [
  {
    path: 'language-selection',
    loadComponent: () => import('./guest-language-selection.component').then((m) => m.GuestLanguageSelectionComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(languageSelectionRoutes)],
  exports: [RouterModule],
})
export class guestLanguageSelectionRoutingModule {
  static routes = languageSelectionRoutes;
}
